export type ApiErrorLike = {
  success?: boolean;
  accessDenied?: boolean;
  status?: number;
  message?: string;
} | null | undefined;

/** True when API / fetch indicates the user is not allowed to view the resource (HTTP 403 / Forbidden). */
export function isApiAccessDenied(r: ApiErrorLike): boolean {
  if (r == null) return false;
  if (r.accessDenied === true) return true;
  if (r.status === 403) return true;
  const m = r.message;
  if (typeof m === 'string') {
    const s = m.trim();
    if (s === 'Forbidden' || /^HTTP 403/.test(s)) return true;
  }
  return false;
}
